import React, {useContext, useState} from 'react';
import {HalfwayContext} from "../../context/HalfwayContext";
import {HalfwayContextType} from "../../types/HalfwayContextType";


const Header = () => {

    const {
        courseInfo,
        courseLoading,
    } = useContext(HalfwayContext) as HalfwayContextType;
    const [failedImageUrl, setFailedImageUrl] = useState<string>();
    const imageUrl = courseInfo.imageUrl?.trim();
    const showImage = Boolean(imageUrl && imageUrl !== failedImageUrl);

    if (courseLoading)
    {
        return (
            <div className="bg-white px-5 pt-5 pb-6">
                <div className='flex flex-col items-start'>
                    <div className="h-16 w-16 rounded-2xl shimmer"></div>
                    <div className="h-6 w-3/4 mt-4 shimmer"></div>
                    <div className="h-4 w-5/6 mt-3 shimmer"></div>
                    <div className="h-4 w-2/3 mt-2 shimmer"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white px-5 pt-5 pb-6">
            <div className='flex flex-col items-start'>
                {showImage && (
                    <img
                        className="h-16 w-16 rounded-2xl object-cover shadow-card"
                        src={imageUrl}
                        alt="Profile"
                        onError={() => setFailedImageUrl(imageUrl)}
                    />
                )}
                <h1 className={`font-bold text-xl ${showImage ? 'mt-4' : 'mt-0'} mb-1 text-slate-900 tracking-tight`}>
                    {courseInfo.name}
                </h1>
                <span className='text-slate-500 text-sm leading-relaxed'>
                    Please place your order below and it will be ready when you finish your first 9. Payment can be made when you reach the halfway house.
                </span>
            </div>
        </div>
    );
};

export default Header;
